module.exports = __webpack_public_path__ + "img/dvf-guide.a2527cdc.png";